var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.507,
    height: 5.349,
    viewBox: "0 0 8.507 5.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(0.706 0.706)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 3.547,
    y2: 3.937,
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 3.547,
    y2: 3.937,
    transform: "translate(3.547)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulldown);
export default __webpack_public_path__ + "static/media/pulldown.f137930531fa92bdbb2a9795ab7c2519.svg";
export { ForwardRef as ReactComponent };